import React, { Component } from 'react';
import { ShipContext } from './context/ShipContext';
import { GlobalContext } from './context/GlobalContext';
import AreaCategoriesList from './AreaCategoriesList';

const MENU_CATEGORY_AREA_ID = "additionaApplicationAreasForOtherVesselTypes";

class AreaCategories extends Component {
    constructor(props) {
        super(props);

        this.state = {
            shouldScroll: false,
            containerHeight: 0,
            containerWidth: 0
        };

        this.containerRef = React.createRef();
        this.contentContainerRef = React.createRef();
        this.checkIfShouldAddScroll = this.checkIfShouldAddScroll.bind(this);
        this.handleCloseBtnClick = this.handleCloseBtnClick.bind(this);
    }

    componentDidMount() {
        this.bindEventListeners();
        this.checkIfShouldAddScroll();
    }

    componentWillUnmount() {
        this.unbindEventListeners();
    }

    bindEventListeners() {
        window.addEventListener('resize', this.checkIfShouldAddScroll, false);
    }

    unbindEventListeners() {
        window.removeEventListener('resize', this.checkIfShouldAddScroll, false);
    }

    checkIfShouldAddScroll() {
        const
            offsetTopAndBottom = 64,
            shipsViewerHeight = document.getElementById('shipsViewerRoot').clientHeight,
            maxContainerHeight = shipsViewerHeight - offsetTopAndBottom,
            contentHeight = this.contentContainerRef.current.scrollHeight,
            containerHeight = this.containerRef.current.clientHeight,
            containerWidth = this.containerRef.current.clientWidth;

        if (contentHeight >= maxContainerHeight && containerHeight > 0) {
            this.setState({
                shouldScroll: true,
                containerHeight: containerHeight,
                containerWidth: containerWidth
            });
        } else {
            this.setState({ shouldScroll: false });
        }
    }

    handleCloseBtnClick() {
        this.props.resetActiveAreas();
        this.props.setCategoriesListVisibility(false);
        if (this.props.moveCameraToInitialPosition) {
            this.props.moveCameraToInitialPosition();
        }
    }

    renderContent() {
        const {
            areaDisplayName,
            areaSubcategories,
            activeAreaId,
            areaId
        } = this.props;

        const content = (
            <div
                className="area-categories__inner"
                ref={this.contentContainerRef}
            >
                <h2 className="area-categories__heading">
                    {areaDisplayName}
                </h2>
                <AreaCategoriesList
                    subcategories={areaSubcategories}
                    isAreaActive={activeAreaId === areaId}
                    checkIfShouldAddScroll={this.checkIfShouldAddScroll}
                    contentContainerRef={this.contentContainerRef.current}
                />
            </div>
        );

        if (this.state.shouldScroll) {
            return (
                <div
                    className='area-categories__scroll-container'
                    style={{
                        height: this.state.containerHeight,
                        width: this.state.containerWidth,
                }}>
                    <div
                        className='area-categories__scroll-inner'
                    >
                        {content}
                    </div>

                </div>
            );
        } else {
            return content;
        }
    }


    render() {
        let style;
        let classStatic = MENU_CATEGORY_AREA_ID == this.props.areaId ? 'static-area-menu' : '';

        if (this.props.activeAreaId === this.props.areaId || (MENU_CATEGORY_AREA_ID == this.props.areaId)) {
            style = {
                opacity: 1,
                visibility: 'visible'
            }
        }

        return (
            <div className={`area-categories ${classStatic}`}
                style={style}
                ref={this.containerRef}
            >
                <button
                    className="close-btn"
                    onClick={this.handleCloseBtnClick}
                />
                {this.renderContent()}
            </div>
        )
    }
}

function

    AreaCategoriesWithContext(props) {
    return (
        <GlobalContext.Consumer>
            {(globalContext) => (
                <ShipContext.Consumer>
                    {(shipContext) => (
                        <AreaCategories
                            activeAreaId={shipContext.activeAreaId}
                            resetActiveAreas={shipContext.resetActiveAreas}
                            setCategoriesListVisibility={globalContext.setCategoriesListVisibility}
                            {...props}
                        />
                    )}
                </ShipContext.Consumer>
            )}
        </GlobalContext.Consumer>
    )
}

export default AreaCategoriesWithContext;